<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MatchingTaxonomiesDataProvider',
  created() {
    this.fetchItems();
  },
  methods: {
    ...mapActions('MatchingTaxonomies', ['fetchItems', 'refresh'])
  },
  computed: {
    ...mapGetters('MatchingTaxonomies', [
      'getTaxonomies',
      'industries',
      'decisionLevels',
      'orgTypes',
      'budgetBrackets',
      'networkingGoals',
      'eventInterestTags',
      'isLoading',
      'failed'
    ])
  },
  render() {
    return this.$scopedSlots.default({
      taxonomies: this.getTaxonomies,
      industries: this.industries,
      decisionLevels: this.decisionLevels,
      orgTypes: this.orgTypes,
      budgetBrackets: this.budgetBrackets,
      networkingGoals: this.networkingGoals,
      eventInterestTags: this.eventInterestTags,
      loading: this.isLoading,
      failed: this.failed
    });
  }
};
</script>
